<template>
  <div>

    <el-tag v-if="['Closed'].includes(status.status)" type="success">Ativo</el-tag>

    <el-tooltip
      v-if="['ErrorSendMkt'].includes(status.status)"
      :content="status.status_message"
      placement="top"
    >
      <el-tag type="warning">Verificar Erro</el-tag>
    </el-tooltip>

    <el-tooltip
      v-if="['Undefined'].includes(status.status)"
      :content="status.status_message"
      placement="top"
    >
      <el-tag type="warning">Indefinido</el-tag> 
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "StatusCaptaMkt",
  props: ["status"],
  data() {
    return {
    };
  },
};
</script>

<style scoped></style>
